import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { memo, useContext, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { Navbar } from '../layouts/Navbar';
import { Sidebar } from '../layouts/Sidebar';

const LayoutRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  maxWidth: '100%',
  paddingTop: 64,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 250,
  },
}));

const AdminRoute = () => {
  const location = useLocation();
  const {
    authState: { user, authLoading, isAuthenticated },
  } = useContext(AuthContext);
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  if (authLoading) {
    return (
      <div
        style={{
          left: '50%',
          top: '50%',
          transform: 'translateY(-50%)',
          position: 'absolute',
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return isAuthenticated ? (
    user?.role !== 'ADMIN' ? (
      <Navigate to="/404" />
    ) : (
      <>
        <Helmet>
          <title>{`Yum Yum`}</title>
          <meta property="og:url" content={window.location.href} />
          <meta property="og:title" content={`Yum Yum`} />
        </Helmet>
        <LayoutRoot>
          <Box
            sx={{
              width: '100%',
              height:
                location.pathname.split('/')[2] === 'revenue'
                  ? '100%'
                  : '100vh',
              bgcolor: '#f5f5f0',
            }}
          >
            <Outlet />
          </Box>
        </LayoutRoot>
        <Navbar onSidebarOpen={() => setSidebarOpen(true)} />
        <Sidebar onClose={() => setSidebarOpen(false)} open={isSidebarOpen} />
      </>
    )
  ) : (
    <Navigate to={`/login?RedirectTo=${location.pathname}${location.search}`} />
  );
};

export default memo(AdminRoute);
